<template>
  <div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
    <masteradmin-sidebar-menu />
    <div class="content-wrapper">
      <div class="container-wrapper center mm_body">
        <div>
          <h3 class="d-inline heading">Add Account</h3>
        </div>
        <div class="heading-seperator"></div>
         <div class="container">
                <div v-show="create_account_errors" class="validate-warning-msg-login">{{ create_account_error_msg }}</div>
                <form @submit.prevent="onSubmit" autocomplete="off">
                <div class="row">
                    <div class="col-md-6">                      
                      <div class="form-group">
                        <input 
                            type="text" 
                            name="first name" 
                            id="first_name"
                            ref="first_name"
                            v-validate="{ rules: { required: true, regex: nameRegex() } }"
                            maxlength="250"
                            v-model="first_name"
                            class="form-control" 
                            placeholder="First Name">
                            <div v-if="verrors.firstByRule('first name', 'required')" class="margin-bottom-5 validate-warning-msg">The first name field is required</div>
                            <div v-if="verrors.firstByRule('first name', 'regex')" class="margin-bottom-5 validate-warning-msg">First name should only contain - and _</div>
                       </div>
                      <div class="form-group">
                        <input 
                            type="text" 
                            name="last name" 
                            id="last_name"
                            ref="last_name"
                            v-validate="{ rules: { required: true, regex: nameRegex() } }"
                            maxlength="250" 
                            v-model="last_name"
                            class="form-control" 
                            placeholder="Last Name">
                            <div v-if="verrors.firstByRule('last name', 'required')" class="margin-bottom-5 validate-warning-msg">The last name field is required</div>
                            <div v-if="verrors.firstByRule('last name', 'regex')" class="margin-bottom-5 validate-warning-msg">Last name should only contain - and _</div>
                      </div>
                       <div class="form-group">
                            <input 
                                type="text"
                                name="email" 
                                id="email"
                                ref="email"
                                v-validate="{ rules: { required: true, email: true } }"
                                maxlength="250" 
                                v-model="email"
                                class="form-control" 
                                placeholder="Email">
                                <div v-if="verrors.firstByRule('email', 'required')" class="margin-bottom-5 validate-warning-msg">The email field is required</div>
                                <div v-if="verrors.firstByRule('email', 'email')" class="margin-bottom-5 validate-warning-msg">The email field must be a valid email</div>
                        </div>                        
                         <div class="form-group">
                            <input 
                                type="text" 
                                name="phone" 
                                id="phone_number"
                                ref="phone_number"
                                v-validate="{ rules: { required: true, regex: phoneRegex() } }"
                                maxlength="14"
                                v-model="phone_number"
                                @keyup="phoneValid"
                                @blur="phoneValid"
                                class="form-control" 
                                placeholder="Phone">                                
                                <div v-if="verrors.firstByRule('phone', 'required')" class="margin-bottom-5 validate-warning-msg">The phone number field is required</div>
                                <div v-if="verrors.firstByRule('phone', 'regex')" class="margin-bottom-5 validate-warning-msg">The phone number format is invalid</div>
                        </div>    
                        <div class="form-group">
                            <input 
                                type="text" 
                                name="company name" 
                                id="org_name"
                                ref="org_name"
                                v-validate="'required'"
                                maxlength="250" 
                                v-model="org_name"
                                class="form-control" 
                                placeholder="Company Name">
                            <div v-show="verrors.has('company name')" class="validate-warning-msg">{{ verrors.first('company name') }}</div>
                        </div>
                       
                        <div class="form-group" id="industry-wrapper">
                            <multiselect v-model="industry_types"
                                :options="industry_options"
                                track-by="value"
                                label="text"
                                placeholder="Select Industry"
                                :multiple="true"
                                :close-on-select="false"
                                :show-labels="false"
                                v-bind:name="'industry_types[]'"
                                v-bind:id="'industry_types'"
                                v-validate="'required'" 
                                >
                                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                            </multiselect>
                            <div v-if="verrors.firstByRule('industry_types[]', 'required')" class="validate-warning-msg"> The industry field is required</div>
                        </div>

                    </div>

                     <div class="col-md-6">  
                          <div class="form-group">                           
                            <input 
                                name="location_api" 
                                id="location_api"
                                ref="location_api"                               
                                class="form-control address-search-icon" 
                                placeholder="Address Search"
                                onfocus="value = ''"
                                value="">
                        </div>
                        <div class="form-group">
                            <input 
                                name="address" 
                                id="org_address"
                                ref="org_address"
                                v-validate="'required'"
                                maxlength="250" 
                                v-model="org_address"
                                class="form-control" 
                                placeholder="Address 1">
                            <div v-if="verrors.firstByRule('address', 'required')" class="margin-bottom-5 validate-warning-msg">The address 1 field is required</div>
                        </div>
                        <div class="form-group">
                            <input 
                                type="text" 
                                name="mailing_address_2" 
                                id="mailing_address_2"
                                ref="mailing_address_2"
                                v-model="mailing_address_2"
                                class="form-control" 
                                placeholder="Address 2"
                                maxlength="250">
                        </div>
                        <div class="form-group">
                            <input 
                                type="text"
                                name="city" 
                                id="org_city"
                                ref="org_city"
                                v-validate="'required'"
                                maxlength="100" 
                                v-model="org_city" 
                                class="form-control" 
                                placeholder="City">
                                <div v-show="verrors.has('city')" class="validate-warning-msg">{{ verrors.first('city') }}</div>
                        </div>                            
                        <div class="form-group">
                            <select 
                                name="state" 
                                id="org_state"
                                ref="org_state"
                                v-validate="'required'" 
                                v-model="org_state" 
                                class="form-control">
                                <option v-for="(type, index) in state_options" :key="index" :value="type.value">{{ type.text }}</option>
                            </select>
                                <div v-if="verrors.firstByRule('state', 'required')" class="margin-bottom-5 validate-warning-msg">The state/province field is required</div>
                        </div>                          
                        <div class="form-group">
                            <input 
                                type="text" 
                                name="zip" 
                                id="org_zip"
                                ref="org_zip"
                                v-validate="{ rules: { required: true, regex: getPostalCodeRegex() } }"
                                v-model="org_zip"
                                maxlength="10"
                                class="form-control" 
                                placeholder="Zip/Postal Code">
                               <div v-if="verrors.firstByRule('zip', 'required')" class="margin-bottom-5 validate-warning-msg">The zip/postal code field is required</div>
                                <div v-if="verrors.firstByRule('zip', 'regex')" class="margin-bottom-5 validate-warning-msg">The zip/postal code format is invalid
</div>
                        </div> 
                        <div class="form-group">
                            <select 
                                name="country"
                                id="org_country"
                                ref="org_country"                    
                                v-model="org_country"
                                v-validate="'required'" 
                                v-on:change="getStateLists(org_country)"
                                class="form-control">
                                    <option v-for="(type, index) in country_options" :key="index" :value="type.value">{{ type.text }}</option>
                                </select>
                                <div v-show="verrors.has('country')" class="validate-warning-msg">{{ verrors.first('country') }}</div>
                        </div> 
                       
                     </div>
         
                 </div>
          
            <div class="text-center" style="margin-top:10px;">
                <button type="submit" class="btn btn-info btn-lg text-center">Add Account</button>
            </div>
        </form>

      </div>
    </div>
  </div>
  </div>
 </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import Multiselect from 'vue-multiselect';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data: function () {
    return {
            industry_types: [],
            industry_options: [],            
            first_name: '',
            last_name: '',
            email: '',                   
            org_name: '',
            org_type: '',                       
            country_options: [],
            state_options:  [],            
            org_address: '',
            org_country: 'US',
            mailing_address_2: '',
            org_city: '',
            org_state: '',
            org_zip: '',
            phone_number: '', 
            create_account_errors: false,
            create_account_error_msg: '',  
    };
  },
  components: {
    UserMenu,
    GoBack,
    MasteradminSidebarMenu,
    Multiselect,
  },
 methods: {
        phoneValid: function(event) {
            var phone = this.phone_number;
            this.phone_number = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },        
        phoneRegex: function() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        getPostalCodeRegex: function() {
            if (this.org_country == "US") {
              return /^[0-9]{5}(?:-[0-9]{4})?$/;
            } else if (this.org_country == "CA") {
              return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
            }
            return /./;
        },
        nameRegex: function() {
          return /^[a-zA-Z-_ ']*$/;
        },        
        getCountryLists: function () {
            axios.get('/custom/account-create-country-lists', {

            })
            .then(response =>  {
              this.country_options = response.data;              
            })
            .catch(function(error) {

            });
        },
        getStateLists: function (CountryCode) {
            this.org_state = ''; 
            if(CountryCode == '') {
              CountryCode = null;
            }
            axios.get('/custom/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
                response.data[0].text = "Select State / Province";                
                this.state_options = response.data;                               
            })
            .catch(function(error) {

            });
        },
        onSubmit() {
            this.create_account_error_msg = '';
            this.$validator.validateAll().then((result) => {
                if(!result){
                    console.log("ERROR" + result)
                    return;
                }
                this.insertAccountUserAction();
            }).catch(() => {
                // catches the error;
            });
        },
        insertAccountUserAction: function() {           
            axios('/custom/create-account-insert',
            {
                method: 'POST',
                data: {
                    "account": {
                        "company_name": this.org_name,
                        "master_admin": false,
                        "school_flag": 'Company',
                        "website": '',
                        "phone_no": '',
                        "phone_ext": '',
                        "fax": '',
                        "status": 'Inactive',                       
                        "researcher_notes": '',
                        "naics_code": '',
                        "naics_id": '',
                        "naics_description": '',
                        "naics_label": '',
                        "location": {
                            "address": this.org_address,
                            "country_code": this.org_country,
                            "state_code": this.org_state,
                            "city": this.org_city,
                            "zip": this.org_zip,
                            "market_area": '',
                            "address2": this.mailing_address_2
                        },
                        "program": 'Mentorship',
                        "industry_selected": this.industry_types,
                        "is_customer_created_account": 1, 
                    },
                    "userInfo": {
                        "uid": 0,
                        'admin_fname': this.first_name,
                        'admin_lname': this.last_name,
                        'admin_email': this.email,                        
                        "phone": this.phone_number,
                        "phone_ext": '',
                        "mobile": '',                       
                        'id_number': '',
                        'admin_title': '',
                        'is_enabled': 0,                       
                        'remove_flag': false,
                        'last_login': "",
                        'no_login': "",                       
                        'is_primaryadmin': 1,                       
                        'is_manager': 1,
                        'admin_status': 'Active'
                    },
                }
            })
            .then(response => {
                this.flash({ message: 'New Account Added Successfully!', variant: 'success' });                        
                this.$router.push('customer-accounts-view-list')
            })
            .catch(error => {
                const fieldErrors =  [];
                const fieldErrors1 =  [];
                var newFieldErr = '';
                var errMsgObj = error.response.data.message;
                Object.keys(errMsgObj).map(key => {
                    if(key == 'org name') {
                        newFieldErr = "Account name is already exists";
                    }
                    else {
                        newFieldErr = "Email address is already exists";
                    }
                });
                this.create_account_error_msg = newFieldErr;
                this.create_account_errors = true;
            });
        },
        placeAddressComponent: function(addressComponents) {
            var assocArray = [];
            for(var i=0; i<addressComponents.length; i++) {
              var data_value = addressComponents[i].short_name;
              var data_key = addressComponents[i].types[0];
              assocArray[data_key] = data_value;
            }
            this.org_zip = this.org_city = this.org_country = this.org_state = this.org_address = this.org_address2 = '' ;
            if(assocArray['postal_code']) {
              this.org_zip = assocArray['postal_code'];              
            }
            if(assocArray['locality']) {
              this.org_city = assocArray['locality'];              
            }
            if(assocArray['country']) {
              this.org_country = assocArray['country'];
              this.getStateLists(this.org_country);              
            }
            if(assocArray['administrative_area_level_1']) {
              this.org_state = assocArray['administrative_area_level_1'];              
            }
            if(assocArray['street_number']) {
              this.org_address = assocArray['street_number'];              
            }
            if(assocArray['route']) {
              if(this.org_address) {
                this.org_address = this.org_address + ' ' + assocArray['route'];
              }
              else {
                this.org_address = assocArray['route'];
              }             
            }
        },
        fetchIndustryOptions: function() {
             axios.get('/custom/industryoptions', {

             })
             .then((response) => {                 
                 for(var i=0; i < response.data.industry.length; i++) {
                   var industry_option = {value: response.data.industry[i].id, text: response.data.industry[i].title};
                   this.industry_options.push(industry_option);
                 }
             })
             .catch(error => {

             });

        }                
    },
    created() { 
        this.getCountryLists();
        this.getStateLists(this.org_country);
        this.fetchIndustryOptions();
        
    },
    mounted() {      
          setTimeout(() => {
            this.autocomplete = new google.maps.places.Autocomplete(
              (this.$refs.location_api),
              {
                types: [],
                componentRestrictions: {country: ['us', 'ca']},
              }
            );
            this.autocomplete.addListener('place_changed', () => {
              let place = this.autocomplete.getPlace();
              this.placeAddressComponent(place.address_components);
            });
          }, 1000);       
    },    
    beforeCreate() {
          let googlePlaceAPI = document.createElement('script');
          googlePlaceAPI.setAttribute('src',"https://maps.googleapis.com/maps/api/js?key=" + process.env.PLACE_API_KEY + "&libraries=places");
          document.head.appendChild(googlePlaceAPI);         
    }    
}
</script>
<style scoped>
.mm_body {
    font-size: 14px !important;
    color: #939393;    
    margin: auto;   
}
.form-control {
    font-size: 14px !important;   
}
.div-center {
    text-align: center;  
}
.pad-30 {
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: -20px !important;
    font-size: 1rem;    
}
.max-780 {max-width: 780px; margin: auto;}

.margin-bottom-30 {margin-bottom: 30px;}
.margin-20 {margin: 20px 0px;}
.margin-bottom-60 {margin-bottom: 60px;}
h3 {    
    font-weight: bold;
    font-size: 22px;
    margin-top: 0px;
    margin-bottom: 0px;
    color: #212529;
}
.container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 130px;
    margin-top: 30px;
}
.address-search-icon {
   padding-left: 45px;
   background: url('~@/assets/search-icon.png') no-repeat left;
   background-color: #FFF;   
}
.col-md-6 {
   padding-right: 60px; 
}
::placeholder {
  color: #999;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
 color: #999;
}
::-ms-input-placeholder { /* Microsoft Edge */
 color: #999;
}
/* media query css start */
@media (max-width: 991px) {
    .pad-60 {padding: 60px 20px;}
}
@media (min-width: 1200px){
    .container {
        width: 850px !important;
    }   
}
@media (min-width:320px) and (max-width: 767px ) {
    .container {
        width: 100% !important;
    }  
}
/* media query css end */
</style>
<style>
#industry-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#industry-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;  
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;  
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size: 1rem;  
}
.multiselect__option--selected {
  font-size: 1rem;
  font-weight: normal !important;  
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 1rem;
  font-weight: 400;
  color: #707070;
  background-color: inherit !important;  
}
.multiselect__placeholder {
   font-size: 16px;
   color: #999; 
}
.multiselect {
  line-height: 15px;
}    
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/add_account.vue